import type { ReactNode } from 'react';

export type ChipTone = 'default' | 'primary' | 'accent' | 'clay' | 'outline';

export interface ChipProps {
  tone?: ChipTone;
  className?: string;
  children: ReactNode;
}

const TONE_CLASSES: Record<ChipTone, string> = {
  default: 'bg-muted text-foreground-soft border-border',
  primary: 'bg-primary-soft text-primary border-transparent',
  accent:  'bg-accent text-accent-foreground border-transparent',
  clay:    'bg-clay-soft text-clay border-transparent',
  outline: 'bg-transparent text-foreground-soft border-border-strong',
};

export function Chip({ tone = 'default', className, children }: ChipProps) {
  const tones = TONE_CLASSES[tone];
  return (
    <span
      className={[
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-[3px]',
        'font-mono text-[11px] uppercase tracking-[0.04em] font-medium',
        'border',
        tones,
        className,
      ].filter(Boolean).join(' ')}
    >
      {children}
    </span>
  );
}
